import { Column, Entity, Index, JoinColumn, OneToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('client_hours_pk', ['fkClientId'], { unique: true })
@Entity('client_hours')
export class ClientHoursEntity extends BaseEntity {
	@Column('int', { name: '_fk_client__id', unique: true, unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: 'opensMonday', nullable: true, length: 255 })
	public opensMonday!: string | null;

	@Column('varchar', { name: 'closesMonday', nullable: true, length: 255 })
	public closesMonday!: string | null;

	@Column('varchar', { name: 'opensTuesday', nullable: true, length: 255 })
	public opensTuesday!: string | null;

	@Column('varchar', { name: 'closesTuesday', nullable: true, length: 255 })
	public closesTuesday!: string | null;

	@Column('varchar', { name: 'opensWednesday', nullable: true, length: 255 })
	public opensWednesday!: string | null;

	@Column('varchar', { name: 'closesWednesday', nullable: true, length: 255 })
	public closesWednesday!: string | null;

	@Column('varchar', { name: 'opensThursday', nullable: true, length: 255 })
	public opensThursday!: string | null;

	@Column('varchar', { name: 'closesThursday', nullable: true, length: 255 })
	public closesThursday!: string | null;

	@Column('varchar', { name: 'opensFriday', nullable: true, length: 255 })
	public opensFriday!: string | null;

	@Column('varchar', { name: 'closesFriday', nullable: true, length: 255 })
	public closesFriday!: string | null;

	@Column('varchar', { name: 'opensSaturday', nullable: true, length: 255 })
	public opensSaturday!: string | null;

	@Column('varchar', { name: 'closesSaturday', nullable: true, length: 255 })
	public closesSaturday!: string | null;

	@Column('varchar', { name: 'opensSunday', nullable: true, length: 255 })
	public opensSunday!: string | null;

	@Column('varchar', { name: 'closesSunday', nullable: true, length: 255 })
	public closesSunday!: string | null;

	@OneToOne(() => ClientEntity, (client) => client.clientHours, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
